export default {
  titles: {
    add: 'thêm cấu hình kênh',
    editor: 'sửa cấu hình công',
    add1: 'thêm tài khoản kênh',
    editor1: 'sửa tài khoản kênh'
  },

  label: {
    accountId: 'ID tài khoản nhận',
    accountId1: 'email tài khoản nhận',
    accountName: 'tên tài khoản nhận',
    accountPassword: 'mật khẩu tài khoản nhận',
    owner: 'chủ tài khoản',
    recipientCode: 'mã code ',
    recipientId: 'id tài khoản nhận',
    recipientName: 'số thiết bị', // 收款渠道名称
    channelName: 'Eo biển tên',
    updateAcct: 'sửa tài khoản',
    updateTime: 'sửa thời gian',
    accountNumber: 'Tài khoản nhận',
    todayTotal: 'tổng nhận  total receive',
    yestodayTotal: 'Tổng nhận hôm trước',

    channelCode: 'mã kênh thanh toán',
    channelType: ' loại thanh toán',
    id: ' mã chính ID',
    createAcct: ' Tạo tài khoản',
    createTime: ' thời gian tạo',
    dayQuota: ' hạn mức mỗi ngày',
    monthQuota: ' hạn mức mỗi tháng',
    name: ' tên kênh thanh toán',
    serviceType: ' loại dịch vụ',
    singleMaxLimit: ' hạn mức chuyển cao nhất',
    singleMinLimit: ' hạn mức chuyển thấp nhất',
    status: 'trạng thái',
    action: 'thao tác',
    h5Logo: 'h5 Logo',
    pcLogo: 'pc Logo',
    supported: 'Hỗ trợ thứ ba',
    refresh: 'để làm mới',
    info: 'Mô tả kênh',
    sort: 'xắp xếp'
  },
  rules: {
    id: ' mã chính ID không được bỏ trống',
    name: ' tên kênh thanh toán không được bỏ trống',

    channelCode: 'mã kênh không được bỏ trống',
    accountNumber: {
      empty: 'tài khoản nhận không được bỏ trống',
      type: 'tài khoản nhận bắt buộc định dạng số',
      min: 'độ dài tài khoản nhận bắt buộc lớn hơn hoặc bằng 8',
      max: 'độ dài tài khoản nhận bắt buộc nhỏ hơn hoặc bằng 32'
    },
    accountId: {
      empty: 'tài khoản nhận không được để trống',
      type: 'email không được để trốn'
    },
    channelName: 'Eo biển tên không được để trống',
    channelType: 'loại thanh toán bắt buộc chọn',
    serviceType: 'loại dịch vụ bắt buộc chọn',
    createAcct: 'tạo tài khoản không được bỏ trống',
    createTime: 'thời gian tạo không được bỏ trống',
    dayQuota: {
      empty: 'hạn mức ngày không được bỏ trống',
      type: 'hạn mức ngày phải là số',
      match: 'hạn mức ngày phải lớn hơn 0'
    },
    singleMaxLimit: {
      empty: 'số tiền một lần chuyển khoản cao nhất không được bỏ trống',
      type: 'hạn mức mỗi ngày phải là số',
      match: 'số tiền cao nhất một lần chuyển khoản phải lớn hơn 0',

      match1: 'số tiền chuyển lớn nhất phải lớn hơn số tiền chuyển nhỏ nhất'
    },
    singleMinLimit: {
      empty: 'số tiền một lần chuyển khoản thấp nhất không được để trống',
      type: 'hạn mức một ngày phải là số',
      match: 'số tiền thấp nhất một lần chuyển khoản phải lớn hơn 0'
    },
    monthQuota: {
      empty: 'hạn mức  tháng không được để trống',
      type: 'hạn mức ngày phải là số',
      match: 'hạn mức hàng tháng phải lớn hơn hạn mức hàng ngày'
    },
    accountName: {
      empty: 'tên tài khoản nhận nhất không được để trống'
    },
    sort: {
      empty: 'xắp xếp khoản nhận nhất không được để trống'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/channel.js